module.exports = __webpack_public_path__ + "img/1697370880310-IMG_7077.png.7313c67f.webp";